module.exports = __webpack_public_path__ + "img/balanca-icon.d4efe886.svg";